<template>
    <p class="display-xs text-neutral-primary mt-2 font-bold">
        <slot /> <span class="heading-sm !lowercase">zł/mies.</span>
    </p>
</template>
